import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import CustomEase from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);



function preloader() {
    const preloader = $qs('[data-name="preloader"]');

    if (!preloader) return;

    const body = $qs('body');
    const preloaderBackground = $qs('[data-target="preloader-background"]', preloader);
    const preloaderText = $qs('[data-target="preloader-text"]', preloader);
    const preloaderWhiteLines = $qsa('[data-target="preloader-white-line"]', preloader);
    const preloaderLimeLines = $qsa('[data-target="preloader-lime-line"]', preloader);
    const preloaderTextWidth = preloaderText.offsetWidth;
    const preloaderTextHorizontalPadding = 104;
    const bannerContainer = $qs('[data-target="banner-container"]');
    const bannerScrollDown = $qs('[data-target="banner-scroll-down"]');

    const timeline = gsap.timeline({ 
        delay: 0.5, 
        onStart: () => {
            // localStorage.setItem('preloader_viewed', 'true');
            // localStorage.setItem('preloader_expiry_date', new Date(Date.now() + 30 * 24 * 60 * 60 * 1000));

            const preloaderExpiryDate = localStorage.getItem('preloader_expiry_date');
            const currentDate = new Date();
            const expiryDate = new Date(preloaderExpiryDate);

            if (preloaderExpiryDate && expiryDate > currentDate) return;
            // localStorage.setItem('preloader_expiry_date', new Date(Date.now() + 30 * 1000));
            localStorage.setItem('preloader_expiry_date', new Date(Date.now() + 30 * 24 * 60 * 60 * 1000));
        },
        onComplete: () => {
            preloader.remove();
            body.classList.remove('overflow-hidden');
        } 
    });

    CustomEase.create('textEaseOut', "M0,0 C0.122,0.556 0.172,0.902 1,1");

    timeline
        .addLabel('white_lines')
        .to(preloaderWhiteLines[0], {
            x: '0%',
            duration: 1,
            ease: 'power3.out'
        }, 'white_lines')
        .to(preloaderWhiteLines[1], {
            x: '0%',
            duration: 1.5,
            ease: 'power3.out'
        }, 'white_lines')
        .addLabel('text', '-=0.5')
        .to(preloaderText, {
            y: '0%',
            duration: 1,
            ease: 'textEaseOut'
        }, 'text')
        .add(() => {
            gsap.to(preloaderBackground, {
                opacity: 0,
                duration: 4,
                ease: 'none'
            })
        }, 'text+=0.25')
        .addLabel('lime_lines', '-=0.9')
        .to(preloaderLimeLines[0], {
            x: '0%',
            duration: 6.5,
            ease: 'power2.inOut'
        }, 'lime_lines')
        .to(preloaderLimeLines[1], {
            x: '0%',
            duration: 7.5,
            ease: 'power2.inOut'
        }, 'lime_lines')
        .to(preloaderText, {
            x: `-${preloaderTextWidth - (window.innerWidth - (preloaderTextHorizontalPadding * 2))}px`,
            duration: 7.5,
            ease: 'power2.inOut'
        }, 'lime_lines')
        .addLabel('end', '-=0.25')
        .to(preloaderText, {
            y: '100%',
            duration: 1,
            ease: 'power3.inOut'
        }, 'end')
        .to([preloaderWhiteLines[0], preloaderLimeLines[0]], {
            x: '100%',
            duration: 0.5,
            ease: 'power3.inOut'
        }, 'end')
        .to([preloaderWhiteLines[1], preloaderLimeLines[1]], {
            x: '100%',
            duration: 0.75,
            ease: 'power3.inOut'
        }, 'end')
        .to(bannerContainer, {
            scale: 1,
            duration: 1,
            ease: 'power3.inOut'
        }, 'end')
        .to(bannerScrollDown, {
            opacity: 1,
            duration: 0.5,
            ease: 'none'
        }, '-=0.25');

    return timeline;
}

export default preloader;